// extracted by mini-css-extract-plugin
export default {"error":"form_error__vEFTx","checkbox":"form_checkbox__v1ix8","form_modal":"form_form_modal__VlURZ","form_label":"form_form_label__LeoZY","input-error":"form_input-error__7NDos"};